<template>
  <div class="growth_values">
    <div class="nav-header">
      <van-nav-bar title="我的成长值" @click-left="leftFn" left-arrow />
    </div>
    <div class="container">
      <!-- 您的总体学习情况 -->
      <div class="common_item study_relation">
        <div class="common_title">
          <date-time titleText="您的总体学习情况" :showDateInfo="dateInfoStudyStatus" :originTime="studyStatusOriginTime" :finallyTime="studyStatusFinallyTime" :formatOriginTime="formatStudyStatusOriginTime" :formatFinallyTime="formatStudyStatusFinallyTime" @startTimeFn="studyStatusStartTime" @endTimeFn="studyStatusEndTime" @dateType="dateType" />
        </div>
        <div class="common_item_card">
          <div class="tip_text" v-if="studyStatusShow">
            <p>{{ tipTitle }}</p>
            <div class="select_wrap">
              <template>
                <el-select v-model="selectValue" @change="selectChange" @visible-change="visibleChange">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </template>
              <span class="arror">
                <img src="../../assets/images/parent-course/deftrangle.png" alt="arror" :class="{ reverse: arrroStyle }" />
              </span>
            </div>
          </div>
          <!-- 学习情况图标 -->
          <div class="echart_container" v-if="studyStatusShow">
            <div id="echart_one" class="echart_one_1"></div>
          </div>
          <!-- 缺省图 -->
          <div class="echart_container" v-if="!studyStatusShow">
            <chart-data />
          </div>
          <div class="load_part1" v-if="studyLoading">
            <loading></loading>
          </div>
          <div class="category_area" v-if="studyStatusShow">
            <dot-category />
          </div>
        </div>
      </div>
      <!-- 学习情况 学习偏好 -->
      <div class="common_item stydy_hobby">
        <div class="common_title">
          <date-time titleText :showDateInfo="hobbyTitleInfo" :originTime="hobbyOriginTime" :finallyTime="hobbyFinallyTime" :formatOriginTime="formatHobbyOriginTime" :formatFinallyTime="formatHobbyFinallyTime" @startTimeFn="hobbyStartTime" @endTimeFn="hobbyEndTime" @dateType="dateType">
            <template v-slot:topText>
              <van-tabs @click="tabClick" v-model="tabValue" title-active-color="#ff8340" title-inactive-color="#999" line-height="0" ref="tab2">
                <van-tab v-for="item in tabContent" :key="item.id" :title="item.type"></van-tab>
              </van-tabs>
            </template>
          </date-time>
        </div>
        <div class="common_item_card">
          <div class="top_tip" v-show="pieShow">
            <dot-category />
          </div>
          <div class="echart_container" v-show="pieShow">
            <div id="echart_two" class="echart_two_2"></div>
          </div>
          <div class="echart_container" v-show="!pieShow">
            <chart-data />
          </div>
          <div class="loading_part" v-show="pieLoading">
            <loading></loading>
          </div>
          <div class="value_percent" v-show="pieShow">
            <div class="value_2" :class="{ active2: articalFlag2 }">
              <p>文章</p>
              <p>{{ articalRate ? articalRate : '0%' }}</p>
            </div>
            <div class="value_1" :class="{ active1: articalFlag1 }">
              <p>视频</p>
              <p>{{ videoRate ? videoRate : '0%' }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 学习占比 雷达图-->
      <div class="common_item study_rate" v-if="radarShow">
        <div class="common_title">
          <date-time titleText="学习占比" showDateInfo="日期筛选" :pickerShow="false" />
        </div>
        <div class="common_item_card">
          <div class="echart_container">
            <div id="echart_three" class="echart_three_2"></div>
          </div>
        </div>
        <div class="loading_part" v-if="loadingStudyRadar">
          <loading />
        </div>
      </div>
      <!-- 学习占比 柱状图-->
      <div class="common_item study_rate_bar" v-show="radarBarShow">
        <div class="common_title">
          <date-time titleText="学习占比" showDateInfo="日期筛选" :pickerShow="false" />
        </div>
        <div class="common_item_card">
          <div class="echart_container">
            <div id="echart_three_bar" class="echart_three_bar1"></div>
          </div>
        </div>
        <div class="loading_part" v-if="loadingStudyBar">
          <loading />
        </div>
      </div>
      <!-- 学习占比无数据状态 -->
      <div class="common_item study_rate" v-show="radarShowNodata">
        <div class="common_title">
          <date-time titleText="学习占比" showDateInfo="日期筛选" :pickerShow="false" />
        </div>
        <div class="common_item_card">
          <div class="echart_container">
            <chart-data />
          </div>
        </div>
      </div>
      <!-- 成长曲线 -->
      <div class="common_item grow_line">
        <div class="common_title">
          <date-time titleText="成长曲线" :showDateInfo="growLineTimeTip" :originTime="growLineOriginTime" :finallyTime="growLineFianllyTime" :formatOriginTime="formatGrowLineOriginTime" :formatFinallyTime="formatgrowLineFianllyTime" @dateType="dateType" @startTimeFn="growthLineStartTime" @endTimeFn="growthLineEndTime" />
        </div>
        <div class="common_item_card">
          <div class="tip_text" v-if="showGrowthLine">
            <p>单位： 总分</p>
          </div>
          <div class="loading_part">
            <loading v-if="lineLoading"></loading>
          </div>
          <div class="echart_container" v-if="showGrowthLine">
            <div id="echart_four" class="echart_one_4"></div>
          </div>
          <div class="echart_container" v-if="!showGrowthLine">
            <div id="echart_four" class="echart_one_4" v-if="!showGrowthLine"></div>
          </div>
          <div class="category_area" v-if="showGrowthLine">
            <dot-category textOne="家庭教养压力" textTwo="家庭教养行为" />
          </div>
          <div class="nodata_part" v-if="!showGrowthLine" style="margin-top:-132px">
            <chart-data />
          </div>
        </div>
      </div>
      <!-- 问券概览 -->
      <div class="common_item paper_read">
        <div class="common_title">
          <date-time titleText="问卷概览" showDateInfo="日期筛选" :pickerShow="false" />
        </div>
        <div class="common_item_card">
          <!-- 压力的柱状图 -->
          <div class="pressure_bar" v-show="pressureBarShow && !showChartNodata">
            <p class="title">家长教养压力</p>
            <p class="unit">单位： 分</p>
            <div class="echart_container">
              <div id="echart_five_1"></div>
            </div>
          </div>
          <!-- 压力的雷达图 -->
          <div class="pressure_radar" v-show="pressureRardaShow && !showChartNodata">
            <p class="title">家长教养压力</p>
            <p class="unit">单位： 分</p>
            <div class="echart_container">
              <div id="echart_five_2"></div>
            </div>
          </div>
          <!-- 压力的缺省图 -->
          <div class="pressure_radar" v-show="showChartNodata">
            <p class="title">家长教养压力</p>
            <p class="unit" v-show="!showChartNodata">单位： 分</p>
            <div class="load_area">
              <loading v-if="loadingQuestion" />
            </div>
            <chart-data />
          </div>
          <!-- 行为的柱状图 -->
          <div class="action_bar" v-show="actionBarShow && !showChartNodata2">
            <p class="title">家长教养行为</p>
            <p class="unit">单位： 分</p>
            <div class="echart_container">
              <div id="echart_six_1"></div>
            </div>
          </div>
          <!-- 行为的雷达图 -->
          <div class="action_radar" v-show="actionRadarShow && !showChartNodata2">
            <p class="title">家长教养行为</p>
            <p class="unit">单位： 分</p>
            <div class="echart_container">
              <div id="echart_six_2"></div>
            </div>
          </div>
          <!-- 行为的缺省图 -->
          <div class="action_radar" v-show="showChartNodata2">
            <p class="title">家长教养行为</p>
            <p class="unit" v-show="!showChartNodata2">单位： 分</p>
            <div class="load_area">
              <loading v-if="loadingQuestion" />
            </div>
            <chart-data />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DateTime from '../../components/common/date-time/index.vue'
  import DotCategory from '../../components/growth-value/dot-category.vue';
  import { decryptBy } from '@/assets/js/encryption';
  import { myEcharts } from '../../assets/base'
  import { _getGorwthLine, _questionPaper, _allStudyStatus, _studyStatusPie, _studyStatusRadar } from '../../api/growth'
  import * as echarts from 'echarts';
  import ChartData from '../../components/common/chart-data.vue';
  import Loading from '../../components/common/is-loading.vue'
  export default {
    name: 'growth-values',
    components: { DateTime, DotCategory, ChartData, Loading },
    props: {},
    data() {
      return {
        loadingStudyRadar: false,//学习情况 偏好的点击事件中的图标loading
        loadingStudyBar: false,//学习情况 偏好的点击事件中的图标loading
        allDatyTime: '',//当前时间 2012-01-01
        parentId: '',
        options: [
          { value: 1, label: '次数' },
          { value: 2, label: '时长' },
        ],
        selectValue: 1,
        arrroStyle: false,//下拉框箭头的样式
        tabValue: 0,//切换tab
        tabContent: [
          { type: '学习情况', id: '10' },
          { type: '学习偏好', id: '11' }
        ],
        // ----------------------------------------------
        // 您的总体学习情况
        studyLoading: false,
        tipTitle: '次数', //次数 或者 时长
        studyStatusShow: true,//是否展示学习情况
        dateInfoStudyStatus: '日期筛选',
        studyStatusOriginTime: '',
        studyStatusFinallyTime: '',
        formatStudyStatusOriginTime: '',
        formatStudyStatusFinallyTime: '',
        allStudyLineParams: {
          startTime: '',
          endTime: '',
          type: 1,//统计类型,1_次数,2_时长
          userId: '',//用户id
          dateType: 1,//1日 2月
        },
        showGrowthLine: false,//有无数据判断是否展示图表--成长曲线
        lineLoading: false,
        // 成长曲线参数
        growLineParams: {
          parentId: '',
          dateType: 1,//1、日2、月
          startTime: '',
          endTime: '',
        },
        growLineTimeTip: '日期筛选',//时间组件右上角时间文字显示
        growthLineDateType: 1, //时间类型，1日 2月
        growLineOriginTime: '',//成长曲线开始时间
        growLineFianllyTime: '',//成长曲线结束时间
        formatGrowLineOriginTime: '',//用来格式化控件选择轴的开始时间
        formatgrowLineFianllyTime: '',//用来格式化控件选择轴的结束时间
        //---------------------------------------------------------------------
        // 学习情况 学习偏好
        pieLoading: false,
        studyPieParams: {
          dateType: 1,//1_日,2_月
          endTime: '',
          startTime: '',
          type: 1,//统计类型,1_学习情况,2_学习偏好
          userId: ""
        },
        hobbyTitleInfo: '日期筛选',//学习情况 偏好的右上角时间显示
        hobbyOriginTime: '',
        hobbyFinallyTime: '',
        formatHobbyOriginTime: '',
        formatHobbyFinallyTime: '',
        pieShow: true,//true有数据,显示饼图
        videoRate: '',
        articalRate: '',
        articalFlag1: false,
        articalFlag2: false,
        //-------------------------------------------------------------------
        //学习占比 雷达图
        radarParams: {
          dateType: 1,//日期类型,1_日,2_月
          docType: '',//统计类型,1_视频,2_文章
          endTime: '',
          startTime: '',
          type: 1, //统计类型,1_学习情况,2_学习偏好
          userId: '',
        },
        radarShow: false,
        radarShowNodata: false,//缺省图是否显示
        radarBarShow: false,//柱状图
        // -----------------------------------------------------------------------
        // 问券概览下,
        pressureBarShow: true,//压力柱状图出现,与压力雷达图互斥
        pressureRardaShow: true,//压力柱状图出现,与压力雷达图互斥
        actionBarShow: true,//行为柱状图出现,与行为雷达图互斥
        actionRadarShow: true,//行为柱状图出现,与行为雷达图互斥
        loadingQuestion: false,//问券的loading
        showChartNodata: false,//教养压力的缺省图显示
        showChartNodata2: false,//教养行为的缺省图显示
      };
    },
    watch: {},
    computed: {},
    methods: {
      leftFn() {
        this.$router.back()
      },
      // 时长 次数 您的学习情况接口请求
      selectChange(val) {
        if (val === 1) {
          this.tipTitle = '次数'
        } else {
          this.tipTitle = '时长'
        }
        this.allStudyLineParams.type = val
        this.allStudyStatus(this.allStudyLineParams)
      },
      // 控制下拉框箭头的样式
      visibleChange() {
        this.arrroStyle = !this.arrroStyle
      },
      // 学习情况 学习偏好的点击切换事件
      tabClick(e, ee) {
        if (e === 0) {
          this.studyPieParams.type = 1 //学习情况
          // 学习占比 雷达图 跟学习偏好一摸一样,共用
          this.radarParams.type = 1
        } else if (e === 1) {
          this.studyPieParams.type = 2 //学习偏好
          // 学习占比 雷达图 跟学习偏好一摸一样,共用
          this.radarParams.type = 2
        }
        // tab点击的时候,学习占比不能显示
        this.radarShow = false
        this.radarBarShow = false
        this.radarShowNodata = false
        this.$nextTick(() => {
          this.studyStatusPie(this.studyPieParams)
        })
      },
      // 监听时间组件类型
      dateType(val) {

        // 月 日
        if (val === 'day') {
          this.growthLineDateType = 1
          this.studyPieParams.dateType = 1
          this.allStudyLineParams.dateType = 1 //时间类型通用
          this.growLineParams.dateType = 1
          sessionStorage.setItem('timeType', 0)
        } else if (val === 'month') {
          this.growthLineDateType = 2
          this.studyPieParams.dateType = 2
          this.allStudyLineParams.dateType = 2 //时间类型通用
          this.growLineParams.dateType = 2
          sessionStorage.setItem('timeType', 1)
        }
      },
      // 您的学习情况时间组件事件
      studyStatusStartTime(val) {
        this.studyStatusOriginTime = val
        this.formatStudyStatusOriginTime = val.split('-').join('/') //为了兼容ios，格式为2012/01/01
      },
      studyStatusEndTime(val) {
        this.studyStatusFinallyTime = val
        this.formatStudyStatusFinallyTime = val.split('-').join('/') //为了兼容ios，格式为2012/01/01
        this.allStudyLineParams.dateType = this.growthLineDateType //时间类型通用
        this.allStudyLineParams.startTime = this.studyStatusOriginTime
        this.allStudyLineParams.endTime = val
        // 发请求获取获取
        // this.allStudyStatus(this.allStudyLineParams)
        // 组图联动
        this.relationChange(this.studyStatusOriginTime, val)
      },
      // 学习情况 学习偏好 时间组件事件
      hobbyStartTime(val) {
        this.hobbyOriginTime = val
        this.formatHobbyOriginTime = val.split('-').join('/') //为了兼容ios，格式为2012/01/01
        // 学习占比 雷达图 跟学习偏好一摸一样,共用
        this.radarParams.startTime = val
      },
      hobbyEndTime(val) {
        this.hobbyFinallyTime = val
        this.formatHobbyFinallyTime = val.split('-').join('/') //为了兼容ios，格式为2012/01/01
        this.studyPieParams.dateType = this.growthLineDateType //时间类型通用
        this.studyPieParams.startTime = this.hobbyOriginTime
        this.studyPieParams.endTime = val
        // 学习占比 雷达图 跟学习偏好一摸一样,共用
        this.radarParams.endTime = val
        this.radarParams.dateType = this.growthLineDateType //时间类型通用
        // this.studyStatusPie(this.studyPieParams)
        // 组图联动
        this.relationChange(this.hobbyOriginTime, val)
      },

      // 成长曲线的时间组件事件
      growthLineStartTime(val) {
        this.growLineOriginTime = val
        this.formatGrowLineOriginTime = val
      },
      // 成长曲线，选择结束时间后，发送请求获取数据
      growthLineEndTime(val) {
        this.growLineFianllyTime = val
        this.formatgrowLineFianllyTime = val.split('-').join('/') //为了兼容ios，格式为2012/01/01
        this.growLineParams.dateType = this.growthLineDateType
        this.growLineParams.startTime = this.growLineOriginTime
        this.growLineParams.endTime = this.growLineFianllyTime
        // this.getGorwthLine(this.growLineParams)
        // 组图联动
        this.relationChange(this.growLineOriginTime, val)
      },
      // 带有时间的接口的组图联动
      relationChange(startTime, endTime) {
        // 总体学习情况
        this.studyStatusOriginTime = startTime
        this.studyStatusFinallyTime = endTime
        this.formatStudyStatusOriginTime = startTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
        this.formatStudyStatusFinallyTime = endTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
        this.allStudyLineParams.startTime = startTime
        this.allStudyLineParams.endTime = endTime
        // 学习情况 学习偏好
        this.hobbyOriginTime = startTime
        this.hobbyFinallyTime = endTime
        this.formatHobbyOriginTime = startTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
        this.formatHobbyFinallyTime = endTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
        this.studyPieParams.startTime = startTime
        this.studyPieParams.endTime = endTime
        // 成长曲线
        this.growLineOriginTime = startTime
        this.growLineFianllyTime = endTime
        this.formatGrowLineOriginTime = startTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
        this.formatgrowLineFianllyTime = endTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
        this.growLineParams.startTime = startTime
        this.growLineParams.endTime = endTime
        // 学习占比
        this.radarParams.startTime = startTime
        this.radarParams.endTime = endTime
        this.radarParams.startTime = startTime
        this.radarParams.endTime = endTime
        // 不显示学习占比
        this.radarShow = false
        this.radarShowNodata = false
        // 数据请求
        this.allStudyStatus(this.allStudyLineParams)
        this.studyStatusPie(this.studyPieParams)
        this.getGorwthLine(this.growLineParams)

      },
      // 您的学习情况 第一张图曲线图
      async allStudyStatus(allStudyLineParams) {
        this.studyLoading = true
        try {
          let res = await _allStudyStatus(allStudyLineParams)
          this.studyLoading = false
          let { code, data, message } = res
          if (res && code === 200) {
            // 时间的逻辑判断
            if (data.beginTime && data.endTime) {
              this.studyStatusOriginTime = data.beginTime
              this.formatStudyStatusOriginTime = data.beginTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
              this.studyStatusFinallyTime = data.endTime
              this.formatStudyStatusFinallyTime = data.endTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
              this.dateInfoStudyStatus = data.beginTime + '至' + data.endTime
            } else {
              this.dateInfoStudyStatus = '日期筛选'
              this.studyStatusOriginTime = this.allDatyTime
              this.formatStudyStatusOriginTime = this.allDatyTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
              this.studyStatusFinallyTime = this.allDatyTime
              this.formatStudyStatusFinallyTime = this.allDatyTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
            }
            // data.data = [
            //     {date: "2021-08-25", videoVal: "3", docVal: "3"},
            //     {date: "2021-08-26", videoVal: "4", docVal: '4'},
            //     {date: "2021-08-27", videoVal: "5", docVal: 6},
            //     {date: "2021-08-28", videoVal: "3", docVal: '10'},
            //     {date: "2021-08-29", videoVal: "7", docVal: '12'},
            //      {date: "2021-08-25", videoVal: "3", docVal: "3"},
            //     {date: "2021-08-26", videoVal: "4", docVal: '4'},
            //     {date: "2021-08-27", videoVal: "5", docVal: 6},
            //     {date: "2021-08-28", videoVal: "3", docVal: '10'},
            //     {date: "2021-08-29", videoVal: "7", docVal: '12'},
            // ]
            //  数据的逻辑处理
            if (data && data.data.length > 0) {
              // 有数据的1状态
              // 时间的数据
              let tempTime = data.data.map(item => item.date)
              // 视频的数据
              let tempVideoInof = data.data.map(item => item.videoVal)
              // 文章的数据
              let tempArticalInof = data.data.map(item => item.docVal)
              // 如果是次数，传单位 次 or  h
              let unit = ''
              if (this.allStudyLineParams.type === 1) {
                unit = '次'
              } else {
                unit = 'min'
              }
              this.$nextTick(() => {
                myEcharts.drawLine('echart_one', tempTime, tempVideoInof, tempArticalInof, unit)
              })
            } else {
              // 无数据，显示缺省图
              this.studyStatusShow = false
            }
          } else {
            // 无数据，显示缺省图
            this.studyStatusShow = false
            this.dateInfoStudyStatus = '日期筛选'
            this.studyStatusOriginTime = this.allDatyTime
            this.formatStudyStatusOriginTime = this.allDatyTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
            this.studyStatusFinallyTime = this.allDatyTime
            this.formatStudyStatusFinallyTime = this.allDatyTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
          }
        } catch (error) {
          this.studyLoading = false
        }
      },
      // 学习情况 学习偏好 第二张饼图
      async studyStatusPie(studyPieParams) {
        this.pieLoading = true
        try {
          let res = await _studyStatusPie(studyPieParams)
          this.pieLoading = false
          let { code, message, data } = res
          if (res && code === 200) {
            // 时间的逻辑处理
            if (data.beginTime && data.endTime) {
              this.hobbyOriginTime = data.beginTime
              this.formatHobbyOriginTime = data.beginTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
              this.hobbyFinallyTime = data.endTime
              this.formatHobbyFinallyTime = data.endTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
              this.hobbyTitleInfo = data.beginTime + '至' + data.endTime
            } else {
              this.hobbyTitleInfo = '日期筛选'
              this.hobbyOriginTime = this.allDatyTime
              this.formatHobbyOriginTime = this.allDatyTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
              this.hobbyFinallyTime = this.allDatyTime
              this.formatHobbyFinallyTime = this.allDatyTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
            }
            // data = {}
            // 当数据为空
            if (Object.keys(data).length === 0) {
              // 无数据,显示缺省图
              this.pieShow = false
            } else {
              this.pieShow = true
            }
            if (data.docNum == 0 && data.videoNum == 0) {
              // 无数据,显示缺省图
              this.pieShow = false
            } else {
              this.pieShow = true
            }
            // 视频所占的百分比
            this.videoRate = data.videoPercent
            this.articalRate = data.docPercent
            let videoInfo = { value: data.videoNum, name: '视频' }
            let articalInfo = { value: data.docNum, name: '文章' }
            let dataArr = [videoInfo, articalInfo]
            this.$nextTick(() => {
              this.drawPie('echart_two', dataArr)
            })
          } else {
            // 无数据,显示缺省图
            this.pieShow = false
            this.hobbyTitleInfo = '日期筛选'
            this.hobbyOriginTime = this.allDatyTime
            this.formatHobbyOriginTime = this.allDatyTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
            this.hobbyFinallyTime = this.allDatyTime
            this.formatHobbyFinallyTime = this.allDatyTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
          }
        } catch (error) {
          this.pieLoading = false
          // 无数据,显示缺省图
          this.pieShow = false
        }
      },
      // 学习占比 第三张雷达图
      async studyStatusRadar(radarParams) {
        this.loadingStudyBar = true
        this.loadingStudyRadar = true
        try {
          let res = await _studyStatusRadar(radarParams)
          this.loadingStudyBar = false
          this.loadingStudyRadar = false
          let { code, message, data } = res
          if (res && code === 200) {
            if (data.dataValue.length > 0) {
              this.radarShowNodata = false
              // cyccyc
              // 当数据小于或者等于3的时候，显示柱状图
              if (data.dataValue.length <= 3) {
                this.radarBarShow = true//显示柱状图
                this.radarShow = false
                let Xdata = data.dataValue.map(item => item.label)
                let Ydata = data.dataValue.map(item => item.value)
                this.$nextTick(() => {
                  setTimeout(() => {
                    myEcharts.drawBar('echart_three_bar', Xdata, Ydata)
                  }, 0);
                })
              } else {
                this.radarShow = true
                this.radarBarShow = false
                let tempArr = data.dataValue.map(item => item.value)
                let theMax = Math.max(...tempArr)
                let indicator1 = []
                data.dataValue.map(item => indicator1.push(Object.assign({}, { name: item.label }, { max: theMax }, { scoreValue: item.value })))
                let dataArr1 = data.dataValue.map(item => item.value)

                // 解决v-show导致的初次渲染高度异常的问题
                this.$nextTick(() => {
                  setTimeout(() => {
                    myEcharts.drawRadar2('echart_three', indicator1, dataArr1)
                  }, 0);
                })
              }

            } else {
              this.radarShow = false
              this.radarBarShow = false//bu显示柱状图
              this.radarShowNodata = true
            }
          } else {
            this.radarShow = false
            this.radarBarShow = false//bu显示柱状图
            this.radarShowNodata = true
          }
        } catch (error) {
          this.radarShow = false
          this.radarBarShow = false//bu显示柱状图
          this.radarShowNodata = true
        }
      },
      // 成长曲线，第四个图
      async getGorwthLine(growLineParams) {
        this.showGrowthLine = false
        this.lineLoading = true //loading 加载
        try {
          let res = await _getGorwthLine(growLineParams)
          let { code, message, data } = res
          this.lineLoading = false //loading 结束
          // 家庭教养压力 家庭教养行为
          if (res && code === 200) {
            // 时间处理
            if (data.start && data.end) {
              this.growLineOriginTime = data.start
              this.growLineFianllyTime = data.end
              this.formatGrowLineOriginTime = data.start.split('-').join('/') //为了兼容ios，格式为2012/01/01
              this.formatgrowLineFianllyTime = data.end.split('-').join('/') //为了兼容ios，格式为2012/01/01
              this.growLineTimeTip = data.start + '至' + data.end
            } else {
              // 当时间后台没有传递数据的时候
              this.growLineTimeTip = '日期筛选'
              this.growLineOriginTime = this.allDatyTime
              this.growLineFianllyTime = this.allDatyTime
              this.formatGrowLineOriginTime = this.allDatyTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
              this.formatgrowLineFianllyTime = this.allDatyTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
            }
            // 数据处理，score1教养压力 score2教养行为
            if (data && data.resultList && data.resultList.length > 0) {
              this.showGrowthLine = true
              let XtimeArray = data.resultList.map((item => item.day))
              let YdataArr1 = data.resultList.map(item => item.score1)
              let YdataArr2 = data.resultList.map(item => item.score2)
              this.$nextTick(() => {
                myEcharts.drawLine('echart_four', XtimeArray, YdataArr1, YdataArr2, '分')
              })
            } else {
              // 无数据情况,显示缺省图
              this.$nextTick(() => {
                myEcharts.clear('echart_four')
              })
              this.showGrowthLine = false
            }
          } else {
            this.showGrowthLine = false
            this.growLineTimeTip = '日期筛选'
            this.growLineOriginTime = this.allDatyTime
            this.growLineFianllyTime = this.allDatyTime
            this.formatGrowLineOriginTime = this.allDatyTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
            this.formatgrowLineFianllyTime = this.allDatyTime.split('-').join('/') //为了兼容ios，格式为2012/01/01
          }
        } catch (error) {

        }
      },
      // 问券调查，最后一个图
      async questionPaper(parentIdParams) {
        this.loadingQuestion = true
        try {
          let res = await _questionPaper(parentIdParams)
          this.loadingQuestion = false
          // res = {
          //     code: 200,
          //     data: {
          //         behavior: {
          //             max: 27,
          //             result: [
          //                 {score: 4, name: "解决问题的方法"},
          //                 {score: 13, name: "监控行为"},
          //                 {score: 20, name: "制止不良行为"},
          //                 {score: 1, name: "制止不良行为"},
          //                 {score: 7, name: "制止不良行为"},
          //                 {score: 11, name: "制止不良行为"},
          //                 {score: 20, name: "制止不良行为"},
          //                 {score: 5, name: "制止不良行为"},
          //                 {score: 12, name: "制止不良行为"},
          //                 {score: 11, name: "制止不良行为"},
          //                 {score: 22, name: "制止不良行为"},
          //                 {score: 27, name: "制止不良行为"},
          //             ]
          //         },
          //         pressure: {
          //             max: 46,
          //             result: [
          //                 {score: 4, name: "解决问题的方法1"},
          //                 {score: 13, name: "监控行为2"},
          //                 {score: 27, name: "制止不良行为3"},
          //                 {score: 27, name: "制止不良行为3"},
          //                 {score: 27, name: "制止不良行为3"},
          //                 {score: 27, name: "制止不良行为3"},
          //                 {score: 27, name: "制止不良行为3"},
          //                 {score: 27, name: "制止不良行为3"},
          //                 {score: 27, name: "制止不良行为3"},
          //                 {score: 27, name: "制止不良行为3"},
          //             ]
          //         }
          //     }
          // }
          // 判断教养压力 家长教养行为是柱状图还是雷达图，如果数据小于等于3柱状图，or雷达图
          let { code, data, message } = res
          if (res && code === 200) {
            // 如果data为空对象,直接显示无数据状态
            if (Object.keys(data).length === 0) {
              this.pressureBarShow = false
              this.pressureRardaShow = false
              this.showChartNodata = true
              this.actionBarShow = false
              this.actionRadarShow = false
              this.showChartNodata2 = true
              return
            }
            let teachPressure = data.pressure //家长教养压力
            let teachAction = data.behavior //家长教养行为
            // 家长教养压力
            if (teachPressure && teachPressure.result.length > 0 && teachPressure.result.length <= 3) {
              this.showChartNodata = false//bu显示缺省图
              // 教养压力有数据,并且小于三条，显示柱状图
              this.pressureBarShow = true
              this.pressureRardaShow = false
              let Xdata = teachPressure.result.map(item => item.name)
              let Ydata = teachPressure.result.map(item => item.score)
              this.$nextTick(() => {
                myEcharts.drawBar('echart_five_1', Xdata, Ydata)
              })
            } else if (teachPressure && teachPressure.result.length > 3) {
              this.showChartNodata = false//显示缺省图
              // 教养压力大于3，显示雷达图
              this.pressureBarShow = false
              this.pressureRardaShow = true
              // let Xdata = teachPressure.result.map(item => item.name)
              let Ydata = teachPressure.result.map(item => item.score)
              let indicatorInfo = []
              teachPressure.result.map(item => {
                return indicatorInfo.push(Object.assign({}, { name: item.name }, { max: teachPressure.max }, { scoreValue: item.score }))
              })
              this.$nextTick(() => {
                myEcharts.drawRadar('echart_five_2', indicatorInfo, Ydata)
              })
            } else {
              // 没有数据，显示缺省图
              this.showChartNodata = true
              this.pressureBarShow = false
              this.pressureRardaShow = false
            }
            // 家长教养行为
            if (teachAction && teachAction.result.length > 0 && teachAction.result.length <= 3) {
              this.showChartNodata2 = false
              // 教养压力有数据,并且小于三条，显示柱状图
              this.actionBarShow = true
              this.actionRadarShow = false
              let Xdata = teachAction.result.map(item => item.name)
              let Ydata = teachAction.result.map(item => item.score)
              this.$nextTick(() => {
                myEcharts.drawBar('echart_six_1', Xdata, Ydata)
              })
            } else if (teachAction && teachAction.result.length > 3) {
              this.showChartNodata2 = false
              // 教养压力大于3，显示雷达图
              this.actionRadarShow = true
              this.actionBarShow = false
              // let Xdata = teachAction.result.map(item => item.name)
              let Ydata = teachAction.result.map(item => item.score)
              let indicatorInfo = []
              teachAction.result.map(item => {
                return indicatorInfo.push(Object.assign({}, { name: item.name }, { max: teachAction.max }, { scoreValue: item.score }))
              })
              this.$nextTick(() => {
                myEcharts.drawRadar('echart_six_2', indicatorInfo, Ydata)
              })
            } else {
              this.showChartNodata2 = true
              // 没有数据，显示缺省图
              this.actionBarShow = false
              this.actionRadarShow = false
            }
          } else {
            this.pressureBarShow = false
            this.pressureRardaShow = false
            this.showChartNodata = true
            this.actionBarShow = false
            this.actionRadarShow = false
            this.showChartNodata2 = true
          }
        } catch (error) {
          // 数据没有，显示缺省图
          this.pressureBarShow = false
          this.pressureRardaShow = false
          this.showChartNodata = true
          this.actionBarShow = false
          this.actionRadarShow = false
          this.showChartNodata2 = true
        }
      },
      //饼图
      drawPie(id, dataArr) {
        let myChart = echarts.init(document.getElementById(id));
        myChart.clear();
        myChart.resize()
        // 阻止点击事件的多次请求
        myChart.off('click');
        let option = {
          series: [
            {
              name: "我的名字",
              type: "pie",
              center: ["50%", "50%"],
              radius: ["45%", "90%"],
              color: ["#ff8340", "#ffd600",],
              label: {
                show: false
              },
              // 修饰引导线样式
              labelLine: {
                show: false,
                // 连接到图形的线长度
                length: 25,
                // 连接到文字的线长度
                length2: 18,
              },
              data: dataArr
            }
          ]
        };
        let _this = this
        myChart.setOption(option, true);
        myChart.on('click', function (params) {
          if (params.name == '文章') {
            _this.articalFlag2 = true
            _this.articalFlag1 = false
            _this.radarParams.docType = 2
          } else if (params.name == '视频') {
            _this.articalFlag2 = false
            _this.articalFlag1 = true
            _this.radarParams.docType = 1
          } else {
            _this.articalFlag2 = false
            _this.articalFlag1 = false
          }
          _this.studyStatusRadar(_this.radarParams)
        })
      }
    },
    beforeCreate() { },
    created() {
      let parentsInfor = JSON.parse(decryptBy(localStorage.getItem("parentsInfor")));
      this.parentId = parentsInfor.id
      this.growLineParams.parentId = parentsInfor.id
      this.allStudyLineParams.userId = parentsInfor.id
      this.studyPieParams.userId = parentsInfor.id
      this.radarParams.userId = parentsInfor.id
      // 当前的时间
      let yearNow = new Date().getFullYear()
      let monthNow = new Date().getMonth() + 1
      let dayNow = new Date().getDate()
      if (+monthNow < 10) monthNow = '0' + monthNow
      if (+dayNow < 10) dayNow = '0' + dayNow
      this.allDatyTime = yearNow + '-' + monthNow + '-' + dayNow
    },
    beforeMount() { },
    mounted() {
      // 您的总体学习情况接口请求
      this.allStudyStatus(this.allStudyLineParams)
      // 问券接口请求
      this.questionPaper(this.parentId)
      // 成长曲线接口请求
      this.getGorwthLine(this.growLineParams)
      // 学习情况 学习偏好
      this.studyStatusPie(this.studyPieParams)
    },
    activated() { },
    deactivated() { },
    beforeDestroy() { },
    destroyed() { }
  };
</script>

<style lang="scss" scoped>
  .el-select-dropdown__item.selected {
    color: rgb(255, 131, 64) !important;
  }
  .growth_values {
    width: 100%;
    height: 100%;
    position: relative;
    .nav-header {
      width: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
    }
    .container {
      padding-top: 60px;
      margin: 0 auto;
      width: 345px;
      // border: 1px solid #ccc;
      .common_item {
        margin-bottom: 22px;
        .common_title {
          height: 22px;
          line-height: 22px;
          width: 100%;
          // border: 1px solid pink;
        }
        .common_item_card {
          margin-top: 10px;
          width: 100%;
          height: 188px;
          border-radius: 6px;
          box-shadow: 0px 9px 13px 0px rgba(214, 214, 214, 0.5);
        }
        // 您的总体学习情况
        &.study_relation {
          position: relative;
          .common_item_card {
            box-sizing: border-box;
            // border: 1px solid red;
            height: 188px;
            .tip_text {
              display: flex;
              justify-content: space-between;
              margin-bottom: 17px;
              font-size: 12px;
              color: #333;
              padding-left: 18px;
              height: 17px;
              line-height: 17px;
              margin-top: 13px;
              .select_wrap {
                padding-right: 6px;
                position: relative;
                .arror {
                  display: inline-block;
                  position: absolute;
                  right: 12%;
                  top: 50%;
                  transform: translateY(-50%);
                  width: 10px;
                  height: 5px;
                  img {
                    transition: all 0.2s linear;
                    height: 100%;
                    &.reverse {
                      transform: rotate(180deg);
                    }
                  }
                }
                ::v-deep .el-select {
                  input.el-input__inner {
                    border: none !important;
                    width: 37px;
                    color: #333;
                    font-size: 12px;
                    height: 17px;
                    line-height: 17px;
                    padding: 0;
                  }
                  span.el-input__suffix-inner {
                    display: none;
                  }
                }
              }
            }
            .echart_container {
              padding-left: 13px;
              #echart_one {
                width: 100%;
                height: 125px;
                // border: 1px solid pink;
              }
            }
            .load_part1 {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
            .category_area {
              margin-top: 3px;
            }
          }
        }
        // 学习情况 学习偏好
        &.stydy_hobby {
          .dateBg {
            white-space: nowrap;
          }
          position: relative;
          .top_text {
            .van-tabs.van-tabs--line {
              width: 148px;
              font-size: 12px;
            }
          }
          .van-tab.van-tab--active {
            font-size: 16px;
          }
          .common_title {
          }
          .common_item_card {
            min-height: 188px;
            .top_tip {
              margin-top: 15px;
            }
            .echart_container {
              // border: 1px solid red;
              width: 146px;
              height: 146px;
              margin: 0 auto;
              #echart_two {
                width: 146px;
                height: 146px;
              }
            }
            .loading_part {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
            .value_percent {
              display: flex;
              justify-content: space-around;
              margin-top: -32px;
              .active1 {
                p {
                  color: #ff8340;
                }
              }
              .active2 {
                p {
                  color: #ffd600;
                }
              }
              // border: 1px solid red;
              p {
                font-size: 12px;
                color: #333;
              }
            }
          }
        }
        // 学习占比-雷达图
        &.study_rate {
          position: relative;
          .common_item_card {
            height: 204px;
            // border: 1px solid red;
            .echart_container {
              width: 100%;
              #echart_three {
                height: 189px;
                // border: 1px solid red;
                width: 100%;
              }
            }
          }
          .loading_part {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        // 学习占比-柱状图
        &.study_rate_bar {
          position: relative;
          .common_item_card {
            height: 130px;
            padding-left: 10px;
            // border: 1px solid red;
            .echart_container {
              width: 100%;
              #echart_three {
                height: 189px;
                // border: 1px solid red;
                width: 100%;
              }
              #echart_three_bar {
                height: 120px;
                width: 100%;
                // border: 1px solid red;
              }
            }
          }
          .loading_part {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        &.grow_line {
          position: relative;
          .common_item_card {
            // border: 1px solid blue;
            height: 204px;
            .tip_text {
              padding-left: 10px;
              margin-top: 10px;
              font-size: 12px;
              color: #333;
              margin-bottom: 19px;
            }
            .loading_part {
              position: absolute;
              transform: translate(-50%, -50%);
              top: 50%;
              left: 50%;
            }
            height: 204px;
            .echart_container {
              padding-left: 13px;
              #echart_four {
                // border: 1px solid red;
                height: 125px;
                width: 100%;
              }
            }
            .category_area {
              margin-top: 3px;
            }
          }
        }
        &.paper_read {
          .common_item_card {
            min-height: 600px;
            padding-bottom: 15px;
            position: relative;
            .loading_part {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
          padding-bottom: 22px;
          // 教养压力的柱状图
          .pressure_bar {
            // 问券概览雷达图的样式
            padding-left: 10px;
            width: 100%;
            // height: 300px;
            // border: 1px solid pink;
            .title {
              font-size: 14px;
              color: #333;
              font-weight: 500;
              margin-bottom: 12px;
            }
            .unit {
              font-size: 12px;
              color: #333;
              margin-bottom: 19px;
            }
            .echart_container {
              #echart_five_1 {
                width: 100%;
                height: 300px;
                // height: 180px;
                margin-top: -12px;
                // border: 1px solid red;
              }
            }
          }
          // 教养压力的雷达图
          .pressure_radar {
            padding-left: 10px;
            width: 100%;
            // height: 170px;
            .title {
              font-size: 14px;
              color: #333;
              font-weight: 500;
              margin-bottom: 12px;
            }
            .unit {
              font-size: 12px;
              color: #333;
              margin-bottom: 19px;
            }
            .echart_container {
              #echart_five_2 {
                width: 100%;
                height: 189px;
              }
            }
          }
          // 问券--教养行为的柱状图
          .action_bar {
            padding-left: 10px;
            width: 100%;
            min-height: 170px;
            // height: 240px;
            margin-top: 17px;
            // border: 1px solid pink;
            .title {
              font-size: 14px;
              color: #333;
              font-weight: 500;
              margin-bottom: 12px;
            }
            .unit {
              font-size: 12px;
              color: #333;
              margin-bottom: 19px;
            }
            .echart_container {
              padding-bottom: 5px;
              #echart_six_1 {
                width: 100%;
                height: 180px;
                margin-top: -12px;
              }
            }
          }
          // 问券--教养行为的雷达图
          .action_radar {
            margin-top: 50px;
            padding-left: 11px;
            // border: 1px solid red;
            .title {
              font-size: 14px;
              color: #333;
              font-weight: 500;
              margin-bottom: 12px;
            }
            .unit {
              font-size: 12px;
              color: #333;
              margin-bottom: 19px;
            }
            .echart_container {
              #echart_six_2 {
                width: 100%;
                min-height: 199px;
                // border: 1px solid red;
              }
            }
          }
        }
      }
    }
  }
  .el-scrollbar {
    > .el-scrollbar__bar {
      opacity: 1 !important;
    }
  }
</style>
